var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"joblist"},[_c('div',{staticClass:"main-wrapper"},[_c('joblistmainheader'),_c('div',{staticClass:"page-wrapper job-wrapper"},[_c('div',{staticClass:"content container"},[_c('joblistheader'),_c('jobcontent')],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }